/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { createAction } from 'typesafe-actions';
export const REDIRECT = "REDIRECT";
export const REDIRECTED = "REDIRECTED";

// Authentication

export const AUTHENTICATE = "AUTHENTICATE";
export const AUTHENTICATE_FAILED = "AUTHENTICATE_FAILED";
export const AUTHENTICATE_SUCCESS = "AUTHENTICATE_SUCCESS";
export const SIGN_OUT = "SIGN_OUT";

// Eval lifecycle

export const CREATE_EVALUATION = "CREATE_EVAL";
export const EVALUATION_CREATED = "EVAL_CREATED";

export const LOAD_EVAL_DATA = "LOAD_EVAL_DATA";

export const LOAD_EVALUATION = "LOAD_EVAL";
export const LOAD_EVALUATION_COMPLETED = "LOAD_EVAL_COMPLETED";

export const LOAD_EVALUATIONS = "LOAD_EVALS";
export const LOAD_EVALUATIONS_COMPLETED = "LOAD_EVALS_COMPLETED";
export const LOAD_WMP_AUDITS = "LOAD_WMP_AUDITS";

export const FETCH_EVALUATION_UPDATES_REQUEST = "FETCH_EVALUATION_UPDATES_REQUEST";
export const FETCH_EVALUATION_UPDATES_SUCCESS = "FETCH_EVALUATION_UPDATES_SUCCESS";
export const FETCH_EVALUATION_UPDATES_FAILURE = "FETCH_EVALUATION_UPDATES_FAILURE";

export const APPLY_EVALUATION_UPDATES = "APPLY_EVALUATION_UPDATES";

export const UPLOAD_EVALUATION = "SUBMIT_EVALUATION";
export const UPLOAD_EVALUATION_SUCCESS = "UPLOAD_EVALUATION_SUCCESS";
export const UPLOAD_EVALUATION_FAILURE = "UPLOAD_EVALUATION_FAILURE";

export const EVAL_PATCH_QUEUED = "EVAL_PATCH_QUEUED";

export const FAILED_PATCH_QUEUED = "FAILED_PATCH_QUEUED";

export const UPLOAD_EVALUATION_PATCH = "SUBMIT_EVALUATION_PATCH";
export const UPLOAD_EVALUATION_PATCH_SUCCESS = "UPLOAD_EVALUATION_PATCH_SUCCESS";
export const UPLOAD_EVALUATION_PATCH_FAILURE = "UPLOAD_EVALUATION_PATCH_FAILURE";

export const SAVE_EVALUATION = "SAVE_EVALUATION";
export const SAVE_EVALUATION_SUCCESS = "SAVE_EVALUATION_SUCCESS";
export const SAVE_EVALUATION_FAILURE = "SAVE_EVALUATION_FAILURE";

export const SET_ACTIVE_EVALUATION = "SET_ACTIVE_EVALUATION";
export const CLEAR_ACTIVE_EVALUATION = "CLEAR_ACTIVE_EVALUATION";

export const SET_ACTIVE_FORM_DEFINITION = "SET_ACTIVE_FORM_DEFINITION";
export const CLEAR_ACTIVE_FORM_DEFINITION = "CLEAR_ACTIVE_FORM_DEFINITION";

export const SYSTEM_SYNC = "SYSTEM_SYNC";

export const syncSystem = createAction(SYSTEM_SYNC);

